import http from 'axios'
import { formatQuery } from '../../lib/formatParams/index'

export default {
  namespaced: true,
  actions: {
    // 获取233网站链接
    GetWebPromoterList({ state }) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/GetWebPromoterList")
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data.errorMsg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    // 网站推广=&gt; 查看
    ViewPromoterUrl({ state }, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/ViewPromoterUrl" + formatQuery(params))
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    // 根据选择的课程生成二维码
    GetPromoterCourse({ state }, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/GetPromoterCourse" + formatQuery(params))
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data.msg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    // 订单推广获取在售课程分类
    getClassIDAndName({ state }, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/GetClassIDAndName" + formatQuery(params))
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data.msg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    //根据分类ID获取课程
    getCourseByClassID({ state }, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/GetCourseByClassID/" + params.id)
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data.msg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    //根据分类ID获取课程
    getCurrentOrderDeail({ state }, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/GetCurrentOrderDeail/" + params.id)
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data.msg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    // 获取当前机构推广订单
    getCurrentUnionPromoterOrder({ state }, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/GetCurrentUnionPromoterOrder" + formatQuery(params))
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data.msg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    // 获取订单推广二维码
    getPromoterOrderUrl({ state }, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/getPromoterOrderUrl/" + params.id)
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data.msg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    // 创建推广订单
    createPromoterOrder({ state }, params) {
      return new Promise((resolve, reject) => {
        http.post("/v1/promoter/CreatePromoterOrder", params,)
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data.msg)
            } else {
              reject(data.msg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    // 编辑推广订单
    editPromoterOrder({ state }, params) {
      return new Promise((resolve, reject) => {
        http.post("/v1/promoter/EditPromoterOrder", params)
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data.msg)
            } else {
              reject(data.msg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    // 删除当前推广订单
    deletePromoterOrder({ state }, params) {
      return new Promise((resolve, reject) => {
        http.post("/v1/promoter/DeletePromoterOrder", params)
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data.msg)
            } else {
              reject(data.msg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    // 获取图片base64
    getUrlBase64({ state }, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/GetUrlBase64" + formatQuery(params))
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data.msg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    // 上传海报
    // https://api.233.com/oss/upload?type=ajax
    // https://upfile.233.com/ajaxupload
    ossUpload({ state }, params) {
      return new Promise((resolve, reject) => {
        http.post("//api.233.com/oss/upload?type=ajax", params,{
          headers:{
          'Content-Type':'multipart/form-data'
          }
        })
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data.list)
            } else {
              reject(data.msg)
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
  }
}